import { SternumTheme } from '@sternum/theme';
import { TooltipTheme } from '@sternum/ui';

import { Colors } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMLightTooltipTheme(theme: SternumTheme): Partial<TooltipTheme> {
  return {
    tooltipBackgroundColor: Colors.Darkest,
    arrowBackgroundColor: Colors.Darkest,
    tooltipColor: Colors.White,
    tooltipBorderRadius: '4px',
    arrowHeight: '8px',
    arrowWidth: '8px',
    arrowBorderRadius: '2px',
    tooltipPadding: '4px 8px',
  };
}
